import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./trainerPortal.css";

export default function AddSubTopic() {
  const navigate = useNavigate();

  const [subTopicData, setSubTopicData] = useState({
    sub_topic_name: "",
    topic: "",
    sub_topic_content: "",
  });

  const [topics, setTopics] = useState([]);
  const [videoFile, setVideoFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchTopics = async () => {
      const courseMaterialId = localStorage.getItem("selectedCourseMaterialId");
      if (!courseMaterialId) {
        setErrorMessage("Course material ID not found.");
        return;
      }
      try {
        const response = await AxiosInstance.get(
          `companies/topics/${courseMaterialId}/`
        );
        setTopics(response.data);
      } catch (error) {
        console.error("Failed to load topics:", error);
        setErrorMessage("Error loading topics.");
      }
    };

    fetchTopics();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubTopicData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "video_link") {
      setVideoFile(files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("sub_topic_name", subTopicData.sub_topic_name);
    formData.append("topic", subTopicData.topic);
    formData.append("sub_topic_content", subTopicData.sub_topic_content);
    if (videoFile) formData.append("video_link", videoFile);

    try {
      await AxiosInstance.post("companies/sub-topic/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Sub-topic added successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Failed to add sub-topic:", error);
      alert("Error adding sub-topic.");
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <>
      {/* Modal backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal container */}
      <div
        className="modal d-block als-trainer-portal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="addSubTopicLabel"
        style={{ backgroundColor: "rgba(11,14,39,0.45)" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addSubTopicLabel">
                Add Sub-Topic
              </h5>
            </div>

            <div className="modal-body">
              {errorMessage && (
                <div className="alert alert-danger" role="alert">
                  {errorMessage}
                </div>
              )}

              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-3">
                  <label className="form-label">Select Topic</label>
                  <select
                    name="topic"
                    className="form-select"
                    value={subTopicData.topic}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select a topic --</option>
                    {topics.map((topic) => (
                      <option key={topic.topic_id} value={topic.topic_id}>
                        {topic.topic_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Sub-Topic Name</label>
                  <input
                    type="text"
                    name="sub_topic_name"
                    className="form-control"
                    value={subTopicData.sub_topic_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Content</label>
                  <textarea
                    name="sub_topic_content"
                    className="form-control"
                    rows="6"
                    placeholder="Write sub-topic content here. You can use - or * for bullets."
                    value={subTopicData.sub_topic_content}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label className="form-label">Video File</label>
                  <input
                    type="file"
                    name="video_link"
                    className="form-control"
                    onChange={handleFileChange}
                    accept="video/*"
                  />
                </div>

                <div className="d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save Sub-Topic
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
